import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

// Agents
export const getAgents = (params) => api.get('/agents', { params });
export const getAgent = (id) => api.get(`/agents/${id}`);
export const getAgentGraph = (id) => api.get(`/agents/${id}/graph`);

// Policies
export const getPolicies = () => api.get('/policies');
export const createPolicy = (data) => api.post('/policies', data);
export const updatePolicy = (id, data) => api.put(`/policies/${id}`, data);
export const deletePolicy = (id) => api.delete(`/policies/${id}`);

// Violations
export const getViolations = (params) => api.get('/violations', { params });
export const resolveViolation = (id) => api.post(`/violations/${id}/resolve`);

// Kill Switch
export const executeKillSwitch = (data) => api.post('/killswitch/execute', data);
export const reactivateAgent = (id) => api.post(`/killswitch/reactivate/${id}`);

// Audit
export const getAuditEvents = (params) => api.get('/audit', { params });

// Connectors
export const getConnectors = () => api.get('/connectors');
export const getConnectorDetail = (id) => api.get(`/connectors/${id}`);
export const testConnector = (id) => api.post(`/connectors/${id}/test`);
export const syncConnector = (id) => api.post(`/connectors/${id}/sync`);

// Discovery
export const triggerDiscoveryScan = () => api.post('/discovery/scan');

// Policy Simulator
export const simulatePoliciesForAgent = (agentId) => api.post(`/policies/simulate-agent/${agentId}`);

// Containment
export const quarantineAgent = (agentId) => api.post(`/containment/quarantine/${agentId}`);

// First Scan Report
export const getFirstScanReport = () => api.get('/reports/first-scan');
export const downloadFirstScanPDF = () => api.get('/reports/first-scan/pdf', { responseType: 'blob' });

// Deployment Gates
export const getDeploymentGates = () => api.get('/deployment-gate/agents');
export const approveDeployment = (gateId) => api.post(`/deployment-gate/${gateId}/approve`);
export const rejectDeployment = (gateId) => api.post(`/deployment-gate/${gateId}/reject`);

// Audit Detail & Export
export const getAuditEventDetail = (eventId) => api.get(`/audit/${eventId}`);
export const exportAuditJSON = () => api.get('/audit/export/json');

// Compliance
export const getComplianceFrameworks = () => api.get('/compliance/frameworks');
export const getSOC2Report = () => api.get('/compliance/soc2');
export const getISO27001Report = () => api.get('/compliance/iso27001');

// Incidents
export const getIncidents = (params) => api.get('/incidents', { params });
export const getIncidentStats = () => api.get('/incidents/stats');

export default api;
